import { Component, Injector, OnInit } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { LocationService } from '../../main-layout/location/location.service';
import { Utilityservice } from '../../utility/utilityservice.service';

@Component({
  selector: 'app-locationmodal',
  templateUrl: './locationmodal.component.html',
  styleUrls: ['./locationmodal.component.css']
})
export class LocationmodalComponent extends BaseClass implements OnInit {

  CSRFToken = '';
  countyList = [];
  hubList = []
  stateList = []
  regionList = []
  cityList = [];
  locationtype = [];
  saveTitle = 'Add'
  LocationForm: FormGroup;
  onlyView: any;
  isEdit: boolean = false;
  organisationList = [];
  activeFlag = [
    {
      'labelname': 'Active',
      'value': 'Y'
    },
    {
      'labelname': 'Inactive',
      'value': 'N'
    }
  ]

  locationTypeLabel: string;
  locationTypeEnabled: string;
  isHubEnabled: string;
  isCityEnabled: string;
  isRegionEnabled: string;
  existingdetails: any = {};
  limitedAccess: string = "N";
  userRole: String;
  countryId: number = 1;
  maxLocationsReached: String;
  oldActiveFlag: String;

  extraDetails: {
    locationTypeLabel?: string; locationTypeEnabled?: string; isHubEnabled?: string;
    isCityEnabled?: string; isRegionEnabled?: string; tssprtlimitedaccess?: string; userRole?: string;maxLocationsReached?: string;[key: string]: any
  } = {};

  constructor(
    private locationService: LocationService,
    private fb: FormBuilder,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef, private locationservice: LocationService,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice
  ) {
    super(injector);
    const dataFromParent = this.config.data;
    this.extraDetails = dataFromParent?.extraDetails || {};
    this.isCityEnabled = this.extraDetails.isCityEnabled;
    this.isRegionEnabled = this.extraDetails.isRegionEnabled;
    this.isHubEnabled = this.extraDetails.isHubEnabled;
    this.locationTypeLabel = this.extraDetails.locationTypeLabel;
    this.locationTypeEnabled = this.extraDetails.locationTypeEnabled;
    this.userRole = this.extraDetails.userRole;
    this.countryId = config?.data?.datas?.[0]?.countryid ?? 1; 
    this.maxLocationsReached = this.extraDetails.maxLocationsReached;
    this.getState(this.countryId);
    this.gettoken();
    if (dataFromParent?.title == 'Modify Location') {
      this.isEdit = true;
      this.saveTitle = 'Modify'
      this.existingdetails = dataFromParent.datas;
      this.limitedAccess = this.extraDetails.tssprtlimitedaccess;
    } 
  }
  public validation_message: any;
  ngOnInit() {
    this.formInitiliaze();
    this.getData();
    this.LocationForm.get('activeflag')?.valueChanges.subscribe((value) => {
      this.updateActiveFlagOptions(value);
    });

    this.updateActiveFlagOptions(this.LocationForm.get('activeflag')?.value);

    this.getCountryList();
    if (this.isCityEnabled == "Y") {
      this.getCityList();
    }
    if (this.locationTypeEnabled == "Y") {
      this.getLocationType();
    }
    if (this.isRegionEnabled == "Y") {
      this.getRegionList();
    }
    if (this.isHubEnabled == "Y") {
      this.getHublist();
    }
    if (this.userRole == "0") {
      this.getOrganisations();
      this.disableAllFieldsExceptActiveFlag();
      this.LocationForm.get('activeflag')?.valueChanges.subscribe((value) => {
        this.updateActiveFlagOptions(value);
      });
      this.updateActiveFlagOptions(this.LocationForm.get('activeflag')?.value);
    }


    this.validation_message = {
      'locationname': [{ type: 'required', message: 'Location Name is required' },
      { type: 'SPACERISTRICTDISALLOWSTARTENDSPACE', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: `Special character not allowed (% and ')` },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      //{ type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
      ],
      'stateid': [{ type: 'required', message: 'State is required' }],
      'countryid': [{ type: 'required', message: 'Country is required' }],
      'locationtypeid': [{ type: 'required', message: `${this.locationTypeLabel} name is required` }],
      'cityid': [{ type: 'required', message: 'City is required' }],
      'hubid': [{ type: 'required', message: 'Hub is required' }],
      'regionid': [{ type: 'required', message: 'Region is required' }],
      address: [
       { type: 'maxlength', message: 'Maximum length exceeded' }]
    }
  }


  disableAllFieldsExceptActiveFlag() {
    Object.keys(this.LocationForm.controls).forEach(controlName => {
      if (controlName !== 'activeflag') {
        this.LocationForm.get(controlName)?.disable();
      }
    });

    this.LocationForm.get('activeflag')?.enable();
  }

  getData() {
    if (this.isEdit) {
      this.patchValueForms(this.existingdetails[0])
    }
  }
  getCountryList() {
    this.locationservice.getcontryforlist().subscribe(res => {
      this.countyList = res;
    })
  }
  getState(countryid) {

    this.locationservice.getstateforlist(countryid).subscribe(res => {
      this.stateList = res;
      if (this.isEdit) {
        this.LocationForm.patchValue({ 'stateid': this.existingdetails[0].stateid })
      }
    })
  }
  getHublist() {
    this.locationservice.gethubforlist().subscribe(res => {
      this.hubList = res;
    })
  }
  getRegionList() {
    this.locationservice.getregionforlist().subscribe(res => {
      this.regionList = res;
      this.LocationForm.patchValue({
        'regionid': this.existingdetails[0]?.regionid
      })
    })
  }
  getCityList() {
    this.locationservice.getcityforlist().subscribe(res => {
      this.cityList = res;
    })
  }
  getLocationType() {
    this.locationService.getLocationtype().subscribe(res => {
      this.locationtype = res;
    })
  }
  getOrganisations() {
    this.locationservice.getOrganisations().subscribe(res => {
      this.organisationList = res;
    })
  }

  updateActiveFlagOptions(flagValue: string) {
    if (flagValue === 'Y') {
      if (this.userRole === "0") {
        this.activeFlag = [
          { labelname: 'Active', value: 'Y' },
          { labelname: 'Inactive', value: 'N' }
        ];
      } else {
        this.activeFlag = [
          { labelname: 'Active', value: 'Y' }
        ];
      }
    } else {
      this.activeFlag = [
        { labelname: 'Active', value: 'Y' },
        { labelname: 'Inactive', value: 'N' }
      ];
    }
  }


  patchValueForms(data) {
    this.LocationForm.patchValue({
      'regionid': data?.regionid,
      'countryid': data?.countryid,
      'hubid': data?.hubid,
      'cityid': data?.cityid,
      'locationtypeid': data?.locationtypeid,
      'address': data?.address,
      'activeflag': data?.activeflag,
      'locationname': data?.locationname,
    });
    this.oldActiveFlag = data?.activeflag;
    this.getState(data?.countryid);
  }
  dismiss() {
    Swal.fire({
      title: "Are you sure to you want to close?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "No",
      denyButtonText: `Yes`
    }).then((result) => {
      if (result.isDenied) {
        this.ref.close();
      }
    });
  }
  formInitiliaze() {
    this.LocationForm = this.fb.group({
      locationname: ['', Validators.compose([Validators.required,
      Validators.maxLength(100),
      Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE),
      Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR) 
      ])],

      stateid: ['', Validators.compose([Validators.required])],
      hubid: ['', Validators.compose([Validators.required])],
      regionid: ['', Validators.compose([Validators.required])],
      countryid: ['', Validators.compose([Validators.required])],
      address: ['', Validators.compose([Validators.maxLength(500)])],
      locationtypeid: ['', Validators.compose([Validators.required])],
      cityid: ['', Validators.compose([Validators.required])],
      activeflag: ['Y']
    });
    if (this.isCityEnabled == "N") {
      this.LocationForm.get('cityid')?.disable();
    }
    if (this.isHubEnabled == "N") {
      this.LocationForm.get('hubid')?.disable();
    }
    if (this.isRegionEnabled == "N") {
      this.LocationForm.get('regionid')?.disable();
    }
    if (this.locationTypeEnabled == "N") {
      this.LocationForm.get('locationtypeid')?.disable();
    }
  }
  // Add New Location
  templocation: any;
  addLocation() {
    if (this.LocationForm.invalid) {
      this.validateAllFormFields(this.LocationForm);
      return;
    }
    else if (this.saveTitle == 'Modify') {
      this.modifyLocation(this.LocationForm.value)
    } else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      }).then((value) => {
        if (value.isConfirmed) {
          let data = this.LocationForm.value;
          data['csrftoken'] = this.CSRFToken
          this.locationService.postlocation(this.LocationForm.value).subscribe((data) => {
            this.templocation = data;
            if (this.templocation.response == 'exists') {
              Swal.fire("Location name already exists!", " ", "error").then(result => {
                //this.ref.close()
              });
            }
            else {
              Swal.fire("Location added successfully!", "", "success").then(result => {
                this.ref.close('Save');
              });
            }
          }, error => {
            if(error.error.response == 'html') {
                  Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                                })
                              }       
                  else{
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.error.error,
              footer: "error status is :" + ' ' + error.status
            });}
          
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
    }
  }

  modifyLocation(data: any) {
    Swal.fire({
      title: "Do you want to save the changes?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Save",
      denyButtonText: `Don't Save`
    })
      .then((value) => {
        if (value.isConfirmed) {           
          let data = this.LocationForm.value; 
          if(this.maxLocationsReached == "Yes" && (data.activeflag == "Y" && this.oldActiveFlag == "N" ))
          {
            Swal.fire({
                    icon: 'warning',
                    title: 'Maximum Allowed Locations Used',
                    text: 'Please Contact Complinity Helpdesk'
                  });
            return;
          }
        
          
          data['csrftoken'] = this.CSRFToken
          data.activeflag = this.LocationForm.get('activeflag').value;
          data.locationid = this.existingdetails[0].locationid 
          this.locationService.modifylocation(this.LocationForm.value).subscribe({
            next: (response: any) => {

              if (response?.response == 'exists') {
                Swal.fire("Location name already exists!", " ", "error").then(result => {
                  //this.ref.close()
                });
              }
              else if (response?.response == 'stateError') {
                Swal.fire("State Compliances are Mapped to this Location; therefore State Cannot be Changed. Location can be changed within same state.", " ", "error").then(result => {
                  this.ref.close()
                });
              }
              else {
                Swal.fire("Location modified successfully!", "", "success").then(() => {
                  this.ref.close();
                });
              }
            },
            error: (error) => {
                if (error.error.response == 'html') {
                      Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                      })
                    }       
              else{ 
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: error.error?.error || "An unexpected error occurred.",
                footer: `Error status is: ${error.status}`
              });}
            }
          });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
          this.ref.close();
        }
      });
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityservice.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    }, error => {
      Swal.fire(error.error.message, '', 'error');
    });
  }
}
